import { render, staticRenderFns } from "./NoTranslation.vue?vue&type=template&id=f8f7af08&"
import script from "./NoTranslation.vue?vue&type=script&lang=js&"
export * from "./NoTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8f7af08')) {
      api.createRecord('f8f7af08', component.options)
    } else {
      api.reload('f8f7af08', component.options)
    }
    module.hot.accept("./NoTranslation.vue?vue&type=template&id=f8f7af08&", function () {
      api.rerender('f8f7af08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/errors/NoTranslation.vue"
export default component.exports